import { Component, inject } from '@angular/core';
import { PageTitleService } from './shared/page-title';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: false
})
export class AppComponent {
  private readonly pageTitle = inject(PageTitleService);

  constructor() {
    this.pageTitle.on();
  }
}
